// extracted by mini-css-extract-plugin
export default {"scheduleContents":"TableThreeWeeklyServiceSchedule_scheduleContents__elg2O","week":"TableThreeWeeklyServiceSchedule_week__chStH","box":"TableThreeWeeklyServiceSchedule_box__q9i8g"};